<template>
  <erp-s-field
      :view="this.fieldView || 'tl'"
      :label="label || 'Tipo Etapa'"
      :helper="helper"
      :no-label="noLabel"
      :helper-position="helperPosition || 'lb'"
      :error="error"
      :label-width="labelWidth"
      :style="fieldStyle"
  >
    <u-select
        @input="__set"
        :loading="loading"
        :multiple="multiple"
        :placeholder="!selectNull ? placeholder || 'Qualquer' : ''"
        :options="status"
        v-model="model"
        propoverClass="select-status-def1"
        :disable="disable"
        :style="inputStyle"
        :simple-border="simpleBorder"
        :size="size || '1'"
    >
    </u-select>
  </erp-s-field>
</template>

<script>
import SelectMixin from '../../../../../mixins/SelectMixin'
import {listTipoEtapas} from '@/domain/processos/services/produtividade'
import {USelect} from "uloc-vue"

export default {
  name: 'ModernTipoEtapaProdutividadeSelect',
  mixins: [SelectMixin],
  props: {
    selectNull: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loading: true,
      list: null
    }
  },
  mounted() {
    this.loading = true
    listTipoEtapas(1000, 1, '')
        .then(({data}) => {
          this.list = data.result || data
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.alertApiError(error)
        })
  },
  computed: {
    status () {
      const s = []
      this.selectNull && s.push({
        label: this.placeholder || 'Qualquer',
        value: null
      })
      if (this.list && this.list.length) {
        this.list.map(status => {
          s.push({
            ...status,
            label: status.nome,
            value: status.id
          })
        })
      }
      return s
    }
  },
  components: {
    USelect
  },
  methods: {
    __updateInternal () {
      this.$nextTick(() => {
        if (this.value !== 'undefined' && this.value !== null && this.model === null) {
          let _cp = JSON.stringify(this.value) // force to update datepicker with actual value
          this.model = ''
          setTimeout(() => {
            this.model = JSON.parse(_cp)
          }, 1)
        }
      })
    }
  }
}
</script>

